import { render, staticRenderFns } from "./BannerUpload.vue?vue&type=template&id=339bb5d6"
import script from "./BannerUpload.vue?vue&type=script&lang=js"
export * from "./BannerUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports